function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.736 10.295a4.5 4.5 0 10.946-4.977m-.078-3.47L3.507 5.914l4.027 1.22",
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
});

function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgReturn;